import getCharts from '../getCharts'
import { FacilityAPI } from '../../constants/api.config'

export default async function FacilityCRUD(mode="SELECT",data = {}) {
  try {
    let json = {ID:data?.id,Name:data.name,Type:data.type, Details:data?.details,Status:data?.status,
      Lat:data?.Lat,
      Lng:data?.Lng,
      Address:data?.Address,
    AddressDetails:JSON.stringify(data?.addressDetails),
    City: data?.city,
    State: data?.state,
    County: data?.county,
    Days: JSON.stringify(data?.days),
OtherDetails:JSON.stringify(data?.otherDetails)}
    json =   JSON.stringify(data)
    const payload = {mode,jsonData:json}
    const res = await getCharts(FacilityAPI, payload)
    return res.data
  } catch (error) {
    return error
  }
}
